import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { ConversationToAddressActivityMessage } from './activity-message/conversation-to-address-activity-message';
import { CreateConversationActivityMessage } from './activity-message/create-conversation-activity-message';
import { CreateConversationLabelActivityMessage } from './activity-message/create-conversation-label-activity-message';
import { DeleteConversationLabelActivityMessage } from './activity-message/delete-conversation-label-activity-message';
import { ExecuteBehaviorActivityMessage } from './activity-message/execute-behavior-activity-message';
import { UpdateConversationActivityMessage } from './activity-message/update-conversation-activity-message';

export type ChatActivityMessageProps = {
  activity: ActivityFeed;
};

export const ChatActivityMessage = ({ activity }: ChatActivityMessageProps) => {
  switch (activity.entity) {
    case 'Conversation':
      switch (activity.activityType) {
        case 'create':
          return <CreateConversationActivityMessage activity={activity} />;
        case 'update':
          return <UpdateConversationActivityMessage activity={activity} />;
        default:
          return null;
      }
    case 'ConversationToAddress':
      switch (activity.activityType) {
        case 'createN2NRelationship':
          return <ConversationToAddressActivityMessage activity={activity} action="create" />;
        case 'deleteN2NRelationship':
          return <ConversationToAddressActivityMessage activity={activity} action="delete" />;
        default:
          return null;
      }
    case 'Behavior':
      switch (activity.activityType) {
        case 'execute':
          return <ExecuteBehaviorActivityMessage activity={activity} />;
        default:
          return null;
      }
    case 'LabelAssignment':
      switch (activity.activityType) {
        case 'create':
          return <CreateConversationLabelActivityMessage activity={activity} />;
        case 'delete':
          return <DeleteConversationLabelActivityMessage activity={activity} />;
        default:
          return null;
      }
    default:
      return null;
  }
};
